import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_3'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_3',
  name: "Which of the following topics are included within the facility's written policies and procedures for anti-harassment and abuse?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'APPROPRIATE_BEHAVIOR_AMONG_BETWEEN_WORKERS_MANAGEMENT_SUPERVISO',
      text: 'Appropriate behavior among/between workers, management, supervisors',
      externalIds: [
        {
          id: 'ms-1--5-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'APPROPRIATE_BEHAVIOR_BY_SECURITY_GUARDS_IF_APPLICABLE_',
      text: 'Appropriate behavior by security guards (if applicable)',
      externalIds: [
        {
          id: 'ms-1--5-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'VIOLENCE_AND_HARASSMENT_IN_THE_WORKPLACE',
      text: 'Violence and harassment in the workplace',
      externalIds: [
        {
          id: 'ms-1--5-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ANTI_DISCRIMINATION',
      text: 'Anti-discrimination',
      externalIds: [
        {
          id: 'ms-1--5-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--5-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-1--5-5f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'APPROPRIATE_BEHAVIOR_AMONG_BETWEEN_WORKERS_MANAGEMENT_SUPERVISO',
                'APPROPRIATE_BEHAVIOR_BY_SECURITY_GUARDS_IF_APPLICABLE_',
                'VIOLENCE_AND_HARASSMENT_IN_THE_WORKPLACE',
                'ANTI_DISCRIMINATION',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-15',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 19000,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
